import Button from "./Button"
import Search from "./Search"
import { Link } from "react-router-dom"

const Uniform = ({ instance, accounts, loginRequest, teacher, admin }) => {
	return (
		<>
			<h3>Uniform Register</h3>
			<Link className='text-link' to='/'>
				<Button title='Main Menu' />
			</Link>
			<Search
				instance={instance}
				accounts={accounts}
				loginRequest={loginRequest}
				teacher={teacher}
				menu='U'
				admin={admin}
			/>
		</>
	)
}

export default Uniform
